import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const Type = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Airway Management Type</InputLabel>
      <Select
        value={moduleValues?.['Type'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Type']: e.target.value,
          }))
        }
        label="Airway Management Type"
      >
        <MenuItem value="OPA">OPA</MenuItem>
        <MenuItem value="NPA">NPA</MenuItem>
        <MenuItem value="iGel">iGel</MenuItem>
        <MenuItem value="LMA">LMA</MenuItem>
        <MenuItem value="Surgical Airway">Surgical Airway</MenuItem>
        <MenuItem value="Needle Cricothyroidotomy">Needle Cric</MenuItem>
        <MenuItem value="ET Intubation">ET Intubation</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default Type
